module.exports = __webpack_public_path__ + "img/articulos7.4c465760.png";